import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPin: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPin"><Path d="M14.3446 1.43066L10.8583 6.66012L2.1488 9.56329L7.58582 15.0003L2.58582 20.0003L4.00003 21.4145L9.00003 16.4145L14.437 21.8515L17.3402 13.142L22.5697 9.65573L14.3446 1.43066Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPin;
